import Vue from 'vue';
import VShowSlide from "v-show-slide";

Vue.use(VShowSlide);

window.axios = require('axios');
window.lodash = require('lodash');

Vue.component('vb-accordion', require('../vue/components/Accordion').default);

new Vue({
    'el': '#page-wrapper',

    comments: true,
})